// @ts-nocheck
import format from 'format-number';
import * as _ from 'lodash-es';
import * as routepath from '@/app/routes';
import logger from '@/app/logger';
import type { ZodSchema } from 'zod';
import type { LocationQuery } from 'vue-router';

let lastId = 0;

export default {
  shuffleArray(array) {
    let currentIndex = array.length,
      temporaryValue,
      randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  },
  newId() {
    lastId++; // FIXME remove global state
    return lastId;
  },
  contactFormsIncludingCitySelection: [
    routepath.home.path,
    routepath.contactPage.path,
    routepath.search.sale.meta.path,
    routepath.corporateAgencyBasePath.path,
    routepath.salesAndMarketing.path,
    routepath.stylingServices.path,
    routepath.diasPage.path,
    routepath.howWeSell.path,
    routepath.changeApartments.path,
    routepath.buyingRequestTask.path,
    routepath.currentNewsItem.path,
    routepath.liekkiSellersService.path,
    routepath.rentingLandingPage.path,
    routepath.sellNewApartments.path,
    routepath.sellingYourCottage.path,
    routepath.agencies.path,
  ],

  contactRequestTypes: {
    SELLING: 'selling',
    BUYING: 'buying',
    LEASE_WANTED: 'leaseWanted',
    LEASE_OFFERED: 'leaseOffered',
  },

  heroTabs: {
    BUYING: 'buying',
    SELLING: 'selling',
    RENTING: 'renting',
  },

  contactFormStrings: [
    {
      id: 'selling',
      action: 'Haluan arviokäynnin',
      question: 'Millaista kohdetta olet myymässä?',
      message: 'Hei, haluaisin hinta-arvion asunnostani:',
    },
    {
      id: 'buying',
      action: 'Olen ostamassa',
      question: 'Millaista kohdetta olet ostamassa?',
      message: 'Hei, olen ostamassa kohdetta',
    },
    {
      id: 'leaseWanted',
      action: 'Haluan vuokrata',
      question: 'Millaista kohdetta olet vuokraamassa?',
      message: 'Hei, olen vuokraamassa kohdetta',
    },
    {
      id: 'leaseOffered',
      action: 'Haluan antaa vuokralle',
      question: 'Millaisen kohteen haluat antaa vuokralle?',
      message: 'Hei, olen antamassa vuokralle kohdetta',
    },
    { id: 'office', action: 'Muu asia', question: '', message: '' },
  ],

  lifeSituationOptions: {
    NONE: 'Valitse',
    EMPLOYEE: 'Työssä',
    STUDENT: 'Opiskelija',
    PARENT_AT_HOME: 'Kotiäiti/-isä',
    PENSIONER: 'Eläkeläinen',
    ENTREPRENEUR: 'Yrittäjä',
    OTHER: 'Muu',
    UNEMPLOYED: 'Työtön',
  },

  stripWhiteSpaces(param) {
    return param.toString().replace(/\s+/g, '');
  },

  stripCommas(param) {
    return param.toString().replace(/,/g, '');
  },

  formatNumber(number, decimals) {
    const rounded = decimals >= 0 ? Number(number).toFixed(decimals) : number;
    const formatter = format({ integerSeparator: ' ', decimal: ',' });
    return formatter(rounded);
  },

  isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  },

  isSafari() {
    return (
      navigator.vendor &&
      navigator.vendor.indexOf('Apple') > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf('CriOS') === -1 &&
      navigator.userAgent.indexOf('FxiOS') === -1
    );
  },

  isNumberParseable(searchTerm) {
    return !_.isNaN(Number(searchTerm));
  },

  isQueryParamValid(filter) {
    if (!filter || !filter.value) {
      return false;
    }
    const isEmptyArray = Array.isArray(filter.value) && filter.value.length === 0;
    const isUndefined = _.isUndefined(filter.value);
    const isNull = _.isNull(filter.value);
    return !isEmptyArray && !isUndefined && !isNull;
  },

  isAlphaNumeric(keycode) {
    const exp = /^([0-9a-z]+)$/i;
    return exp.test(keycode);
  },

  parseRoundedInt(stringVal) {
    if (stringVal && !_.isNaN(Number(stringVal))) {
      return Math.round(parseFloat(stringVal));
    } else {
      return null;
    }
  },

  inputFocusOnAndroid(event) {
    // workaround for Android Chrome bug: focused input is sometimes hidden behind the keyboard:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=270018
    if (navigator && navigator.userAgent.match(/android/i)) {
      event.target.parentNode.scrollIntoView();
    }
  },

  sortByName(personList) {
    return personList.sort((a, b) => {
      let result = 0;
      if (a.name < b.name) result = -1;
      if (a.name > b.name) result = 1;
      return result;
    });
  },

  trimNames(personList) {
    return personList.map((person) => {
      const newPersonObj = Object.assign({}, person);
      newPersonObj.name = newPersonObj.name.replace(/^[ \t]+|[ \t]+$/g, '');
      return newPersonObj;
    });
  },

  deduplicate(list, key) {
    const uniqueList = [];
    list.forEach((item) => {
      if (!uniqueList.find((duplicate) => duplicate[key] === item[key])) {
        uniqueList.push(item);
      }
    });
    return uniqueList;
  },

  getErrorCode(err) {
    return err.response && err.response.status && _.isNumber(err.response.status) ? err.response.status : 500;
  },

  stripQuery(url) {
    if (url.indexOf('?') === -1) {
      return url;
    }
    return url.substring(0, url.indexOf('?'));
  },

  splitPathToParts(path) {
    path = this.stripQuery(path);
    return path.substring(path.indexOf('/') + 1).split('/');
  },

  nameToPathFormat(name: string) {
    return name ? name.toLowerCase().replace(/ä/g, 'a').replace(/ö/g, 'o') : name;
  },

  loadImages(document, isImg, callback?) {
    const selector = isImg ? 'img[data-src]' : 'div[data-src]';
    const allElements = Array.from(document.querySelectorAll(selector)); // querySelectorAll produces NodeList
    const elementCount = allElements.length;

    allElements.forEach((elem, index) => {
      const image = new Image();
      const src = elem.getAttribute('data-src');
      image.src = src;
      image.onload = () => {
        if (isImg) {
          elem.src = src;
        } else {
          elem.style.backgroundImage = `url(${src})`;
        }
        elem.removeAttribute('data-src');

        if (typeof callback === 'function' && index === elementCount - 1) {
          callback();
        }
      };
    });
  },

  removeHtmlTags(html) {
    return html.replace(/(<([^>]+)>)/gi, '');
  },

  urlFriendlyString(str) {
    return str
      .toLowerCase()
      .replace(/[,.;:?!–\-"'´`+/()=]/g, '')
      .replace(/[äå]/g, 'a')
      .replace(/[ö]/g, 'o')
      .replace(/\s+/g, '-');
  },

  capitalizeMultiPartWords(word: string | undefined) {
    return (
      word &&
      _.reduce(
        word.split('-'),
        (result, part, index) => (index === 0 ? _.capitalize(part) : `${result}-${_.capitalize(part)}`),
        ''
      )
    );
  },

  numberHasLeadingZeros(num) {
    return /\D|^0+/.test(num);
  },

  validateFloat(num) {
    return /^[1-9]\d*(?:\.\d{1,2})?$/.test(num);
  },

  validateInt(num) {
    return /^[0-9]+$/.test(num);
  },

  replaceCommaWithDot(num) {
    return num.replace(',', '.');
  },
  getMetaTagsForPage(title: string, description?: string, imageUrl?: string, noIndex: boolean = false) {
    const tags = [
      { vmid: 'title', name: 'title', content: title },
      ...(description ? [{ vmid: 'description', name: 'description', content: description }] : []),
      { vmid: 'og:title', property: 'og:title', content: title },
      ...(description ? [{ vmid: 'og:description', property: 'og:description', content: description }] : []),
      ...(imageUrl ? [{ vmid: 'og:image', property: 'og:image', content: imageUrl }] : []),
      { vmid: 'twitter:title', property: 'twitter:title', content: title },
      ...(description ? [{ vmid: 'twitter:description', property: 'twitter:description', content: description }] : []),
      ...(imageUrl ? [{ vmid: 'twitter:image', property: 'twitter:image', content: imageUrl }] : []),
      { vmid: 'twitter:card', property: 'twitter:card', content: 'summary_large_image' },
      {
        vmid: 'google-site-verification',
        name: 'google-site-verification',
        content: 'IVmQji25SgCzkoCbTHsJgkHwX1R8F_rqx-Ees6KcMlE',
      },
    ];

    if (noIndex) {
      tags.push({ vmid: 'robots', name: 'robots', content: 'noindex' });
    }

    return tags.filter((entry) => !!entry.content);
  },
  parseRouteQuery(query: LocationQuery, schema: ZodSchema<any>): object | undefined {
    const result = schema.safeParse(query);
    if (result.error) {
      logger.info('Request url validation failed', result.error);
      return undefined;
    }
    return result.data;
  },
  /**
   * Updates the original object with the properties of the update object so that the original object retains Vue reactivity.
   * This is needed when updating an object wrapped with Vue's reactive() function. You cannot use = assignment nor spread operator.
   */
  updateReactiveObject(originalObj: any, updateObj: any) {
    // Update properties one by one to avoid losing reactivity
    Object.keys(originalObj).forEach((key) => {
      // Reset properties from original object that are not in the updateObj
      if (!(key in updateObj)) {
        originalObj[key] = undefined; // Not deleting to keep reactivity
      }
    });
    // Assign updated properties
    Object.assign(originalObj, updateObj);
  },
  setFocusForAccessibility(element: HTMLElement | undefined | null, focusOptions?: FocusOptions) {
    if (element) {
      element.setAttribute('tabindex', '-1');
      element.focus(focusOptions);
    }
  },
};
